import { isAbove, isBelow } from "./comparisons";

export const SUPER_TREND_UP = -1;
export const SUPER_TREND_DOWN = 1;

const valueOrZero = (value) => (Number.isFinite(value) ? value : 0);

/**
 * One step of SuperTrend exactly as TV Std.supertrend: bands hl2 ± ATR ×
 * multiplier that only tighten while the close stays inside them; the line
 * follows the lower band in an up trend and the upper one in a down trend.
 * The state of the bar is written to `state` at `index`, so a tick can
 * calculate the last bar again from the one before.
 *
 * @param {object[]} bars
 * @param {number} index
 * @param {number[]} atr - average true range per bar
 * @param {number} multiplier
 * @param {{ lower: number[], upper: number[], line: number[], direction: number[] }} state
 */
export const superTrendAt = (bars, index, atr, multiplier, state) => {
  const { high, low, close } = bars[index];
  const middle = (high + low) / 2;
  const previousClose = index > 0 ? bars[index - 1].close : NaN;
  const previousLower = valueOrZero(state.lower[index - 1]);
  const previousUpper = valueOrZero(state.upper[index - 1]);
  const lowerBand = middle - atr[index] * multiplier;
  const upperBand = middle + atr[index] * multiplier;
  const lower =
    isAbove(lowerBand, previousLower) || isBelow(previousClose, previousLower) ? lowerBand : previousLower;
  const upper =
    isBelow(upperBand, previousUpper) || isAbove(previousClose, previousUpper) ? upperBand : previousUpper;
  // Without the previous ATR the trend starts down; then it flips when the close crosses the band the line was on
  let direction = SUPER_TREND_DOWN;

  if (Number.isFinite(atr[index - 1])) {
    const wasOnUpper = state.line[index - 1] === previousUpper;

    if (wasOnUpper) direction = close > upper ? SUPER_TREND_UP : SUPER_TREND_DOWN;
    else direction = close < lower ? SUPER_TREND_DOWN : SUPER_TREND_UP;
  }

  state.lower[index] = lower;
  state.upper[index] = upper;
  state.direction[index] = direction;
  state.line[index] = direction === SUPER_TREND_UP ? lower : upper;
};
